import { useState, useCallback } from "react";
import { ModalType } from "../types/ModalTypes";

export const useModalManagement = () => {
  const [isBottomSheetOpen, setIsBottomSheetOpen] = useState(false);
  const [isCenterSheetOpen, setIsCenterSheetOpen] = useState(false);
  const [modalType, setModalType] = useState<ModalType>(ModalType.Settings);

  const openBottomSheet = useCallback((type: ModalType) => {
    setModalType(type);
    setIsBottomSheetOpen(true);
  }, []);

  const closeBottomSheet = useCallback(() => {
    setIsBottomSheetOpen(false);
  }, []);

  const openOnDeleteAccountAlert = useCallback(() => {
    setIsCenterSheetOpen(true);
  }, []);

  const closeCenterSheet = useCallback(() => {
    setIsCenterSheetOpen(false);
  }, []);

  return {
    isBottomSheetOpen,
    isCenterSheetOpen,
    modalType,
    openBottomSheet,
    closeBottomSheet,
    openOnDeleteAccountAlert,
    closeCenterSheet,
  };
}; 